import React, { useEffect, useState } from "react";
import "./mailbox_styles/logobar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUsers,
    faVideo,
    faCalendarDays,
    faCircleInfo,
    faGear,
    faComments
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Logo } from "./images/infy.svg";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";


const Logobar = () => {
    const themeColor = useSelector((state) => state.themeColor);
    const usersData = useSelector((state) => state.userData);

    const location = useLocation();
    const currentPath = location.pathname;
    const currentLogo = currentPath.split("/")[1];
    const [logobarActiveIcon, setLogobarActiveIcon] = useState(currentLogo);

    useEffect(() => {
        setLogobarActiveIcon(currentLogo)
    }, [currentLogo]);

    const handleClickLogobarActiveIcon = (icon) => {
        setLogobarActiveIcon(icon);
    }

    return (
        <>
            <div className="logobar_container">
                <Link to="/">
                    <div className="logo">
                        <Logo height="20px" width="54px" className="app_logo_color" style={{ fill: themeColor }} />
                    </div>
                </Link>
                <div className="parent_icon_container">
                    <Link to="/task-board" className={`${logobarActiveIcon === "task-board" || logobarActiveIcon === "" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("task-board")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faCalendarDays} className="icons activeIcon" />
                        </div>
                    </Link>
                    <Link to="/mailbox/inbox" className={`${logobarActiveIcon === "mailbox" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("mailbox")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faUsers} className="icons" />
                        </div>
                    </Link>
                    <Link to="/messages" className={`${logobarActiveIcon === "messages" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("messages")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faComments} className="icons" />
                        </div>
                    </Link>
                    <Link to="/meetings" className={`${logobarActiveIcon === "meetings" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("meetings")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faVideo} className="icons" />
                        </div>
                    </Link>
                    <Link to="/info" className={`${logobarActiveIcon === "info" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("info")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faCircleInfo} className="icons" />
                        </div>
                    </Link>
                    <Link to="/settings" className={`${logobarActiveIcon === "settings" ? "active_logobar_icon" : ""
                        }`} onClick={() => handleClickLogobarActiveIcon("settings")}>
                        <div className="iconContainer">
                            <FontAwesomeIcon icon={faGear} className="icons" />
                        </div>
                    </Link>
                </div>
                <Link to="/profile">
                    <div className="profile">
                        <img src={usersData.photoURL} alt="profile_image" height="40px" width="40px" className="profileLogo" />
                    </div>
                </Link>
            </div>
        </>
    );
};

export default Logobar;
